import logo from "@/assets/hustlemate-logo.png";

export default function BrandLogo({ className = "h-7 w-7" }) {
  return (
    <img
      src={logo}
      alt=""
      aria-hidden="true"
      className={`brand-logo shrink-0 object-contain ${className}`}
    />
  );
}
